<template>
    <div class="mt-4">
        <h5 class="status-label">Connection Information</h5>
        <template v-if="model?.credentials?.org_id && model?.credentials?.token?.instance_url">
            <el-row :gutter="20">
                <el-col :span="24">
                    <span><b>Instance URL:</b> {{ model.credentials.token.instance_url }}</span>
                </el-col>
                <el-col :span="24">
                    <span><b>ID:</b> {{ model.credentials.token.id }}</span>
                </el-col>
                <el-col :span="24">
                    <span><b>Organization ID:</b> {{ model.credentials.org_id }}</span>
                </el-col>
            </el-row>
        </template>
        <template v-if="model?.credentials?.token.scope">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                    <span><b>Scopes:</b> <code>{{ model.credentials.token.scope }}</code></span>
                </el-col>
            </el-row>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        },
    }
}
</script>
